module.exports = __webpack_public_path__ + "img/menu1.df2a7b90.png";